import { BlogPostFM, parseDate } from '@bm-js/atlascloud-shared'
import { LinkComponentType } from './CLink'
import { ResponsiveImage } from './ResponsiveImage'

type Props = {
  post: BlogPostFM
  i?: number
  LinkComponent: LinkComponentType
}

export const BlogPost = ({ post, i, LinkComponent }: Props) => {
  const isFirst = i === 0
  const firstHeight = 'h-[calc(96px_*_3_+_1rem)]'
  return (
    <div
      className={`shadow relative
      ${isFirst ? 'row-span-3 ' + firstHeight : 'row-span-1 bg-neutral-50 h-24'}
    `}
    >
      <LinkComponent
        className='no-underline hover:no-underline'
        href={`/nyheter/${post.slug}`}
      >
        <div
          className={`${
            isFirst ? '' + firstHeight : 'flex h-24 gap-2 items-center'
          }`}
        >
          <div
            className={`${
              isFirst
                ? "relative after:content-[''] after:absolute after:inset-0 after:bg-[linear-gradient(rgba(0,0,0,0)_0%,_rgba(0,0,0,0.1)_40%,_rgba(0,0,0,0.3)_65%,_rgba(0,0,0,0.5)_100%)]"
                : 'w-32 shrink-0'
            }`}
          >
            <ResponsiveImage
              file={post.image}
              className={`object-cover w-full ${
                isFirst ? firstHeight : 'h-24'
              }`}
            />
          </div>
          <div
            className={`whitespace-nowrap  overflow-hidden ${
              isFirst
                ? 'absolute bottom-4 left-4 w-[calc(100%_-_2rem)]'
                : 'px-4'
            }`}
          >
            <p
              className={`text-xs truncate ${
                isFirst ? 'text-neutral-300' : 'text-neutral-500'
              }`}
            >
              {parseDate(post.date)}
            </p>
            <h3
              className={`truncate text-lg font-semibold ${
                isFirst ? 'text-white' : 'text-customerPrimary-400'
              }`}
            >
              {post.title}
            </h3>
            <p
              className={`truncate text-xs ${
                isFirst ? 'text-white' : 'text-neutral-500'
              }`}
            >
              {post.summary}
            </p>
          </div>
        </div>
      </LinkComponent>
    </div>
  )
}
